import React from 'react'
import ErrorBoundary from '../../../components/ErrorBoundary'
import RestrictedWordsPage from "../../../components/settings/restricted/RestrictedWordsPage"

const RestrictedWordsPageWithBoundary = (props) => (
    <ErrorBoundary
        componentName="RestrictedWordsPage"
        showReload
        logToBackend
        title="Erro em Palavras-chave"
        message="Ocorreu um erro ao carregar as palavras-chave. Tente recarregar."
    >
        <RestrictedWordsPage {...props} />
    </ErrorBoundary>
)

export default RestrictedWordsPageWithBoundary
